var ElementGetter = require('./abstract/element');
var AbstractFacade = require('../../abstract/facade');

module.exports = GroupGetter;

function GroupGetter () {}
GroupGetter.prototype = new ElementGetter();
GroupGetter.prototype.constructor = GroupGetter;

GroupGetter.prototype.initialize = function () {
  var editor = INKIVE.Tool.getInstance().editor;
  this.canvas = editor.canvas;

  this.structure = {
    'id': null,
    'position': { 'x': null, 'y': null },
    'size': { 'width': null, 'height': null },
    'elements': null,
    'rotation': null,
    'opacity': null,
    'locked': null,
    'link': null
  };
};

GroupGetter.prototype.getLink = function () {
  return svgedit.utilities.getHref(this.element);
};

GroupGetter.prototype.getElements = function () {
  return _.chain($(this.element).children(':not(title)'))
    .sortBy(function (element) {
      return -$(element).index();
    })
    .map(function (element) {
      return { id: element.getAttribute('id'), type: this.getType(element) };
    }, this)
    .value();
};

GroupGetter.prototype.getType = AbstractFacade.prototype.getType;
